import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import StronaTytulowa from "./StronaTytulowa";
import DlaczegoMy from "./DlaczegoMy";
import CoZyskasz from "./CoZyskasz";
import Opinie from "./Opinie";
import Formularz from "./Formularz";
import SpotkajmySie from "./SpotkajmySie";
import WybierzCel from "./WybierzCel";
import FAQ from "./FAQ";
import Narzedzia from "./Narzedzia";
import { FirmSection, FamilySection } from "./DodatkoweSciezki";
import { GuidePreview } from "../DecisionGuides";

const SerceFinansow = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const source = new URLSearchParams(search).get("source") || "";
    const fromContactSource = source.startsWith("kalkulator-") || source === "narzedzia" || source === "formularz";
    if (pathname !== "/formularz" && !fromContactSource) return undefined;

    const timer = window.setTimeout(() => {
      document.getElementById("formularz-pola")?.scrollIntoView({
        behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start",
      });
    }, 150);

    return () => window.clearTimeout(timer);
  }, [pathname, search]);

  useEffect(() => {
    if (pathname !== "/" || !hash) return undefined;

    const timer = window.setTimeout(() => {
      const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
      document.getElementById(hash === "#formularz" ? "formularz-pola" : decodeURIComponent(hash.slice(1)))?.scrollIntoView({
        behavior: reducedMotion ? "auto" : "smooth",
        block: "start",
      });
    }, 100);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return (
    <>
      <StronaTytulowa />
      <WybierzCel />
      <div id="poznaj-nas"><DlaczegoMy /><Opinie compact /></div>
      <CoZyskasz />
      <Narzedzia />
      <FirmSection />
      <FamilySection />
      <GuidePreview />
      <FAQ />
      <div id="porozmawiajmy"><Formularz /><SpotkajmySie /></div>
    </>
  );
};

export default SerceFinansow;

